<div
  class="referral-code-container"
  [class.referral-code-container-t2]="theme() === GbTheme.ThemeTwo"
>
  <div class="referral-input d-flex">
    <input
      type="text"
      [value]="referralCode()"
      readonly
      class="form-input primary-font-regular"
      [class.form-input-theme-two]="theme() === GbTheme.ThemeTwo"
    />
    @if (referralCode()) {
      <button
        class="copy-icon primary-button"
        (click)="copyReferralCode()"
        [class.copy-button-theme-two]="theme() === GbTheme.ThemeTwo"
        [class.rounded-pill]="theme() === GbTheme.ThemeOne"
        [attr.aria-label]="isCopied() ? 'Copied' : 'Copy referral code'"
      >
        @if (theme() === GbTheme.ThemeOne) {
          @if (isCopied()) {
            <!-- Checkmark SVG for Theme One -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M8.6 15.1L15.65 8.05L14.25 6.65L8.6 12.3L5.75 9.45L4.35 10.85L8.6 15.1ZM10 20.5C8.61667 20.5 7.31667 20.2373 6.1 19.712C4.88334 19.1867 3.825 18.4743 2.925 17.575C2.025 16.6757 1.31267 15.6173 0.788001 14.4C0.263335 13.1827 0.000667933 11.8827 1.26582e-06 10.5C-0.000665401 9.11733 0.262001 7.81733 0.788001 6.6C1.314 5.38267 2.02633 4.32433 2.925 3.425C3.82367 2.52567 4.882 1.81333 6.1 1.288C7.318 0.762667 8.618 0.5 10 0.5C11.382 0.5 12.682 0.762667 13.9 1.288C15.118 1.81333 16.1763 2.52567 17.075 3.425C17.9737 4.32433 18.6863 5.38267 19.213 6.6C19.7397 7.81733 20.002 9.11733 20 10.5C19.998 11.8827 19.7353 13.1827 19.212 14.4C18.6887 15.6173 17.9763 16.6757 17.075 17.575C16.1737 18.4743 15.1153 19.187 13.9 19.713C12.6847 20.239 11.3847 20.5013 10 20.5Z"
                fill="white"
              />
            </svg>
          } @else {
            <!-- Checkmark SVG for Theme Two -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clip-path="url(#clip0_1793_182132)">
                <path
                  d="M15 1H4C2.9 1 2 1.9 2 3V16C2 16.55 2.45 17 3 17C3.55 17 4 16.55 4 16V4C4 3.45 4.45 3 5 3H15C15.55 3 16 2.55 16 2C16 1.45 15.55 1 15 1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM18 21H9C8.45 21 8 20.55 8 20V8C8 7.45 8.45 7 9 7H18C18.55 7 19 7.45 19 8V20C19 20.55 18.55 21 18 21Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_1793_182132">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          }
        }
        @if (theme() === GbTheme.ThemeTwo) {
          @if (!isCopied()) {
            <!-- Copy SVG for Theme One -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
              class="rtl"
            >
              <g clip-path="url(#clip0_1413_40816)">
                <path
                  d="M15 1H4C2.9 1 2 1.9 2 3V16C2 16.55 2.45 17 3 17C3.55 17 4 16.55 4 16V4C4 3.45 4.45 3 5 3H15C15.55 3 16 2.55 16 2C16 1.45 15.55 1 15 1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM18 21H9C8.45 21 8 20.55 8 20V8C8 7.45 8.45 7 9 7H18C18.55 7 19 7.45 19 8V20C19 20.55 18.55 21 18 21Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1413_40816">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          } @else {
            <!-- Copy SVG for Theme Two -->

            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rtl"
            >
              <g clip-path="url(#clip0_6001_63443)">
                <path
                  d="M15 1H4C2.9 1 2 1.9 2 3V16C2 16.55 2.45 17 3 17C3.55 17 4 16.55 4 16V4C4 3.45 4.45 3 5 3H15C15.55 3 16 2.55 16 2C16 1.45 15.55 1 15 1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM18 21H9C8.45 21 8 20.55 8 20V8C8 7.45 8.45 7 9 7H18C18.55 7 19 7.45 19 8V20C19 20.55 18.55 21 18 21Z"
                  fill="white"
                />
              </g>
              <path
                d="M11 14.25L12.5 15.75L15.5 12"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <defs>
                <clipPath id="clip0_6001_63443">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          }
        }
      </button>
    }
  </div>
</div>
